var ResponsiveBackground = (function () {
  var currentBreakpoint;

  Utility.log('ResponsiveBackground.js loaded');

  /* * **************************************************************************
   * EXECUTE
   * Loops through the elements in the site that contain the class name of
   * 'acr-responsive-background-behavior' and runs the render() function.
   * The function expects to get 6 images from the data attributes of the
   * element in the form of 'data-img-small-1x' The size identifiers are
   * small, medium and large. The pixel dfensity identifier is 1 and 2.
   * For example you can setup this responsive background behavior like this:
     <section class="acr-responsive-background-behavior"
        data-img-xsmall-1x="../../img/awards-xsmall-1x.jpg"
        data-img-xsmall-2x="../../img/awards-xsmall-2x.jpg"
        data-img-medium-1x="../../img/awards-medium-1x.jpg"
        data-img-medium-2x="../../img/awards-medium-2x.jpg"
        data-img-large-1x="../../img/awards-large-1x.jpg"
        data-img-large-2x="../../img/awards-large-2x.jpg"
        data-img-xlarge-1x="../../img/awards-xlarge-1x.jpg"
        data-img-xlarge-2x="../../img/awards-xlarge-2x.jpg"
     </section>
   *************************************************************************** */
  function execute() {
    var $element;

    $('.acr-responsive-background-behavior[responsified!="true"]:not(.shown)')
      .each(function () {
        // Will only execute if the element is in view, i.e.: lazy loading
        if (Utility.isElementInView(this, false, 300)
            // Don't Lazy Load while on Sitecore's Experience Editor
            || window.location.href.match(/sc_mode/) !== null) {
          $element = $(this);

          render(this);

          $element.addClass('shown');

          if ($element.hasClass('acr-responsive-background-setheight')) {
            setHeight(this);
          } else if (Grid && $element.hasClass('hmc-grid-100')) {
            Grid.resize();
          }

          if ($element.hasClass('broadcast-image-load')) {
            broadcastImageLoad(this, $element.data('type'));
          }
        }
      });
  }

  function render(element, attribute) {
    try {
      var bkg;

      var currentBreakpoint;

      var currentRatio;

      var attr = '';

      var $element;

      $element = $(element);


      if (attribute) {
        if (Object.prototype.toString.call(attribute) === '[object String]') {
          attr = attribute;
        } else {
          Utility.error('ResponsiveBackground.apply(selector, attribute) is '
                + 'expecting a String as an attribute but received a '
                + Object.prototype.toString.call(attribute));
        }
      } else {
        currentBreakpoint = Utility.getCurrentBreakpoint();
        currentRatio = currentBreakpoint.ratio;

        // TODO: REMOVE THIS IF WHEN RETINA APPROACH BECOMES GLOBAL
        if ($(element).data('retina') === 'off') {
          currentBreakpoint.ratio = 1;
        }

        attr = 'data-img-' + currentBreakpoint.breakpoint + '-'
          + currentBreakpoint.ratio + 'x';
      }

      // get the data attribute from the section element
      bkg = $element.attr(attr);

      if (bkg) {
        // check to make sure the image isn't the same so we're not
        // unnecessarily calling the css() function from jQuery
        if ($element.data('acrVarCurrentResponsiveBkg') !== bkg) {
          $element.data('acrVarCurrentResponsiveBkg', bkg);

          $element.css('background-image', 'url(\'' + bkg + '\')');
        }
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }

  /* * **************************************************************************
   * SETHEIGHT
   * If the element has the class "acr-responsive-background-setheight
   * then set its height automatically remaining the image aspect ratio
     <section
     class="
       acr-responsive-background-behavior
       acr-responsive-background-setheight
       "
       ...
     </section>
   *************************************************************************** */
  function setHeight(element) {
    try {
      var width; var height; var widthEle; var heightEle; var
        ratio;

      var imageSrc = element
        .style
        .backgroundImage
        .replace(/url\((['"])?(.*?)\1\)/gi, '$2')
        .split(',')[0];

      var image;

      if (imageSrc && imageSrc !== '') {
        image = new Image();

        image.onload = function () {
          width = image.width;

          height = image.height;

          ratio = width / height;

          widthEle = $(element).width();

          heightEle = Math.floor(widthEle / ratio);

          if (heightEle !== $(element).height()) {
            $(element).css({
              height: heightEle + 'px',
            });
          }
        };

        image.src = imageSrc;
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }

  function broadcastImageLoad(element, type) {
    try {
      var image;
      var imageSrc = element
        .style
        .backgroundImage
        .replace(/url\((['"])?(.*?)\1\)/gi, '$2')
        .split(',')[0];

      if (imageSrc && imageSrc !== '') {
        image = new Image();

        image.onload = function () {
          $(document).trigger(type, imageSrc);
        };

        image.src = imageSrc;
      }
    } catch (e) {
      Utility.error(e.message);
    }
  }

  function init() {
    try {
      // only call resize function every 250ms if multiple resize events are
      // detected so that the browser doesn't freeze from overloaded event calls
      var resizeFunc = Utility.debounce(function () {
        var checkBreakpoint = Utility.getCurrentBreakpoint();

        if (checkBreakpoint.breakpoint !== currentBreakpoint) {
          $('.acr-responsive-background-behavior[responsified!="true"]')
            .removeClass('shown');

          currentBreakpoint = checkBreakpoint.breakpoint;

          execute();
        }
      }, 250);

      // onscroll - debounced 100ms
      $(window).on('scroll', Utility.debounce(function () {
        execute();
      }, 100));

      $(window).resize(resizeFunc); // add resize handler to window

      execute();
    } catch (e) {
      Utility.error('ResponsiveBackground.init() can only be called after '
        + 'DOMContentLoaded Event is triggered. Try calling from Main.js ready '
        + 'function. Error: ' + e.message);
    }
  }

  // Expose the following variables and functions
  return {
    execute: execute,
    setHeight: setHeight,
    init: init,
  };
}());
